export const ACCOUNT_VERIF_TYPES = {
  // Expected from BE
  CREATED: 'Created',
  VERIFIED: 'Verified',
  APPROVED: 'Approved',
  // UI logic
  OBTAINING: 'OBTAINING',
  NOT_OBTAINED: 'NOT_OBTAINED'
};

export const ACCOUNT_TYPES = {
  // Expected from BE
  INVESTOR: 'Investor',
  AGENT: 'Agent',
  // UI logic
  OBTAINING: 'OBTAINING',
  NOT_OBTAINED: 'NOT_OBTAINED'
};

// TD-2192 — after 3 wrong TOTP codes the backend refuses every MFA code check
// (verify, disable, rotation) for the user and marks the refusal with this
// top-level `code`, plus `retryAfterSeconds` left on its lock. Key on the code,
// never on the message text.
export const MFA_LOCKED_CODE = 'MFA_LOCKED';
// Used when the response carries no usable retryAfterSeconds.
export const MFA_LOCK_FALLBACK_SECONDS = 300;
